import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.BulkCreateJobsModal.title',
    defaultMessage: 'Create jobs',
  },
})
